export default __webpack_public_path__ + "static/media/Google dark.b980adb2.svg";